import MultiDropdown, { TMultiDropdown } from '@/shared/Inputs/MultiDropdownInput'
import { CSSProperties, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import { IOption } from '@/types/global.ts'
import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import organizationsAtom from '@/pages/Organizations/organizations.atom.ts'

interface IProps {
  selected: IOrganization['id'][]
  onSelect: (organizationIds: IOrganization['id'][], name: string) => void
  name: string
  title?: string
  type?: TMultiDropdown
  panelStyle?: CSSProperties
}

const OrganizationsMultiSelect = (props: IProps) => {
  const organizations = useRecoilValue(organizationsAtom).items

  const options: IOption<IOrganization['id']>[] = useMemo(() => {
    return organizations.map((m) => ({ title: m.name, value: m.id }))
  }, [organizations])

  return (
    <MultiDropdown
      options={options as any}
      onSelect={props.onSelect}
      title={props.title || 'Выберите орагнизацию'}
      selectedOptions={props.selected as any}
      name={props.name}
      panelStyle={props.panelStyle}
      type={props.type || 'input'}
    />
  )
}

export default OrganizationsMultiSelect
